<template>
  <div class="container-fluid mycontainer-fluid content">
    <br />
    <a @click="$parent.hidePlan()">&#x025c2; Вернуться к документам</a>
    <br />
    <br />
    <!--<div class="content-title content-mb-14">
      21. Состав оборудования в проекте, планируемого к приобретению за счет
      средств займа
    </div>
    <EquipmentZaim></EquipmentZaim>-->
    <div class="content-title content-mb-14">
      1. Наименование промышленного оборудования
    </div>
    <EquipmentIndustrial></EquipmentIndustrial>
    <div class="content-title content-mb-14">
      2. Оборудование, приобретаемое в лизинг
    </div>
    <EquipmentBuyLizing></EquipmentBuyLizing>

    <div class="content-title content-mb-14">
      3. Место эксплуатации промышленного оборудования
    </div>
    <uf_place_industrial_equipment></uf_place_industrial_equipment>
  </div>
</template>

<script>
import { ProjectsService } from "@/common/api.service";
import UFDopInfo from "@/components/project/form/partial/UFDopInfo";
import EquipmentZaim from "@/components/project/form/partial/EquipmentZaim";
import EquipmentIndustrial from "@/components/project/form/partial/EquipmentIndustrial";
import EquipmentBuyLizing from "@/components/project/form/partial/EquipmentBuyLizing";
import uf_place_industrial_equipment from "@/components/project/form/partial/uf_place_industrial_equipment";
export default {
  name: "step7lizing",
  components: {
    EquipmentBuyLizing,
    EquipmentIndustrial,
    EquipmentZaim,
    UFDopInfo,
    uf_place_industrial_equipment
  },
  props: ["step", "project"],

  data() {
    return {
      siteUrl: "",
      FILE_DOCUMENTS_PATH: [],
      showDD: true
    };
  },
  mounted() {
    this.getDocInfo();
  },
  methods: {
    getFileName(file) {
      let p = file.split("/");
      return p[p.length - 1];
    },
    getDocInfo() {
      ProjectsService.getDocumentESProjects(2845).then(({ data }) => {
        data.FILE_DOCUMENTS_PATH[14373]
          ? (this.FILE_DOCUMENTS_PATH = data.FILE_DOCUMENTS_PATH[14373])
          : (this.showDD = false);
      }, this);
    }
  }
};
</script>

<style scoped></style>
